import { SummaryCard, type SummaryCardProps } from './SummaryCard';

export interface SummaryCardsGridProps {
  cards: Omit<SummaryCardProps, 'className'>[];
  columns?: {
    mobile?: number;
    tablet?: number;
    desktop?: number;
  };
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function SummaryCardsGrid({
  cards,
  columns = { mobile: 1, tablet: 2, desktop: 4 },
  gap = 'md',
  className = '',
}: SummaryCardsGridProps) {
  if (cards.length === 0) {
    return null;
  }

  const gapClass = gap === 'sm' ? 'gap-2' : gap === 'md' ? 'gap-4' : 'gap-6';

  // Build grid classes properly - use specific Tailwind classes
  const mobileCols = columns.mobile === 1 ? 'grid-cols-1' : columns.mobile === 2 ? 'grid-cols-2' : columns.mobile === 3 ? 'grid-cols-3' : 'grid-cols-4';
  const tabletCols = columns.tablet === 1 ? 'md:grid-cols-1' : columns.tablet === 2 ? 'md:grid-cols-2' : columns.tablet === 3 ? 'md:grid-cols-3' : 'md:grid-cols-4';
  const desktopCols = columns.desktop === 1 ? 'lg:grid-cols-1' : columns.desktop === 2 ? 'lg:grid-cols-2' : columns.desktop === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-4';

  const gridClass = `grid ${mobileCols} ${tabletCols} ${desktopCols} ${gapClass}`;

  return (
    <div className={`${gridClass} ${className}`}>
      {cards.map((card, index) => (
        <SummaryCard key={index} {...card} />
      ))}
    </div>
  );
}

